import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRemove = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 12,
		cy: 12,
		r: 11,
		fill: "#fff",
		stroke: "currentColor"
	}), /* @__PURE__ */ _jsx("rect", {
		x: 6,
		y: 11.339,
		width: 12,
		height: 1.666,
		fill: "currentColor"
	})]
});
export default SvgRemove;
